define('gen/views',["app/views/baseview","app/views/carousel","app/views/default","app/views/form","app/views/gallery","app/views/google-map","app/views/home","app/views/image","app/views/inquiries","app/views/location","app/views/menu-detail","app/views/menu-list","app/views/modal","app/views/page","app/views/preloader"],function(){

return ;

});

